<!-- 复诊提醒中 其他会话列表 -->
<template>
  <div class="other-processing-sessions">
    <div
      class="tips"
      :class="[prop.isCurrent ? 'currentTips' : '']"
      v-if="subTaskReserveInfo?.morningContent || subTaskReserveInfo?.afternoonContent"
    >
      <div v-if="subTaskReserveInfo?.morningContent">{{ subTaskReserveInfo.morningContent }}</div>
      <div v-if="subTaskReserveInfo?.afternoonContent">
        {{ subTaskReserveInfo.afternoonContent }}
      </div>
    </div>
    <div class="list" v-for="(item, index) in list" :key="index">
      <div>
        <div class="info z-fixed">
          <div class="name" :style="getOpenChatHandle(item, chartId).infoStyle">
            {{ item.name }}
            {{ reVisitRolesCard[item.role].role }}
            <div class="text" :style="getOpenChatHandle(item, chartId).infoStyle">
              {{ getHandleInfo(item) }}
            </div>
          </div>
          <!-- 显示会话中或者是显示打开会话 -->
          <!-- 患者：在非完成中显示 -->
          <!-- 医生：一直显示 -->
          <div
            class="right"
            v-if="(item.role === 'PATIENT' && !item.taskStatus) || item.role === 'DOCTOR'"
            @click="getOpenChatHandle(item, chartId).handle(item, store, emit)"
            :style="getOpenChatHandle(item, chartId).style"
          >
            {{ getOpenChatHandle(item, chartId).title }}
          </div>
        </div>
        <!-- <div class="text">{{ getHandleInfo(item) }}</div> -->
      </div>
      <div class="status" v-if="item.role === 'PATIENT' && item.reserveDataFlag">
        {{ handleReserveData(item) }}
      </div>
      <div
        class="status"
        v-if="item.role === 'PATIENT' && !item.reserveDataFlag && item.sourceDisplayContent"
      >
        {{ item.sourceDisplayContent }}
      </div>
      <!-- 判断状态是显示button还是文案 -->
      <div>
        <!-- 展示文案 -->
        <div class="centent-box" v-if="item.taskStatus">
          <div v-for="(cItem, cIndex) in item.operatorContent" :key="cIndex">
            <div class="cententStyle" v-if="cItem">
              <div><auth-img :src="iconSrc" class="leftIcon" alt="" /></div>
              <div v-html="cItem" />
            </div>
          </div>
        </div>
        <!-- 显示button -->
        <div class="btn-box" v-else>
          <template v-for="(caItem, caIndex) in reVisitRolesCard[item.role].buts" :key="caIndex">
            <a-button
              :class="['button', caItem.disabled(item, list) ? 'btnDisabled' : 'btn']"
              :disabled="caItem.disabled(item, list)"
              @click="handleClick(item, caItem)"
            >
              {{ caItem.title }}
            </a-button>
          </template>
        </div>
      </div>
    </div>
    <!-- 修改复诊日期弹窗 -->
    <SetRetreatment ref="treatmentRef" :isBatch="isBatch" @dueCallBack="dueCallBack" />
    <!-- 痕迹检测 -->
    <TraceDetection ref="traceRef" />
  </div>
</template>
<script setup>
import { useStore } from 'vuex'
import { computed, ref, onMounted, defineProps, defineEmits, watch } from 'vue'
import SetRetreatment from './setRetreatment.vue'
import { apiSubTaskReserveQuery, subTaskStatus } from '@/api/workPlace/retreatment'
import { reVisitType, getTimePeriod, reVisitRolesCard, getOpenChatHandle } from './config'
import { haveProcessingOrder } from '@/api/workPlace/workOrder'
import { debounce, omit } from 'lodash-es'
import { Modal } from 'ant-design-vue'
import { handleTimeShowWeek } from '@/utils'
import { REFRESH_LIST, REFRESH_MAIN } from '@/views/WorkPlace/handleEventBuss'
import { FINISH_ORDER } from '@/views/WorkPlace/handleEventBuss'
import TraceDetection from './orderInspection'
import { setStorage, getStorage } from '@/utils/auth'
import moment from 'moment'
import { useReadStatus } from '../../../../hooks'
const { finishPrecheck } = useReadStatus()

const traceRef = ref(null)
const store = useStore()
const iconSrc = require('@/assets/img/finish.png')
const userInfo = computed(() => store.getters.userInfo)
//患者复诊日程弹窗
const treatmentRef = ref(null)
//当前高亮群
const chartId = computed(() => store.state.workOrder.chartId)
const curGroupInfo = computed(() => store.state.workOrder.workOrderGroupInfo)
const workOrderGroupInfo = ref({})
// 是否是批量
const isBatch = ref(false)
// 复诊列表数据
const list = ref([])
// 复诊提醒子工单数据
const subTaskReserveInfo = ref({})
// 当前选中的数据
const curItem = ref({})
const emit = defineEmits(['getTaskReserveList'])
const prop = defineProps({
  // 工单信息
  info: {
    type: Object,
    default: () => {
      return {}
    }
  },
  // 是否选中当前工单
  isCurrent: {
    type: Boolean,
    default: false
  }
})
watch(
  () => prop.info,
  (newVal, oldVal) => {
    getList()
  },
  { deep: true }
)
watch(
  () => curGroupInfo.value,
  val => {
    workOrderGroupInfo.value = val || {}
  },
  {
    deep: true,
    immediate: true
  }
)
onMounted(() => {
  getList()
})

// 获取列表
const getList = async () => {
  const params = {
    workOrderId: prop.info.workOrderId,
    subTaskBusinessType: 'DA_CURE_RESERVE_ORDER'
  }
  await apiSubTaskReserveQuery(params).then(res => {
    const { reserveSubTaskRecordResponse: p = [] } = res
    subTaskReserveInfo.value = res
    // 医生数据
    const doctorData = {
      taskId: res.taskId,
      name: res.doctorName,
      ucDoctorId: res.ucDoctorId,
      doctorName: res.doctorName,
      taskStatus: res.taskStatus, // 任务状态: 0 未完成 1 已完成
      operatorContent: res.operatorContent,
      doctorGroupId: res.doctorGroupId,
      limitTime: res.limitTime, // 选择复诊日期时间限制时间
      role: 'DOCTOR'
    }
    const doctorInfoList = res.ucDoctorId ? [doctorData] : []
    // 子待办患者数据
    const patientList =
      p?.length > 0
        ? p.map(item => {
            return {
              name: item.patientName,
              ...item,
              role: 'PATIENT',
              limitTime: res.limitTime
            }
          })
        : []
    // 子待办需要根据当前会话中进行排序
    // list.value = [...doctorInfoList, ...moveItemToFront(patientList, chartId.value)]
    // 子待办需要根据当前会话中进行排序取消置顶
    list.value = [...doctorInfoList, ...patientList]
    removeInspectionData()
  })
  emit('getTaskReserveList', list.value)
}
// 回收缓存的工单质检
function removeInspectionData() {
  // 如果子任务失效、完成或工单失效，则回收工单质检暂存内容
  list.value?.forEach(item => {
    if (item.taskStatus) {
      const workOrderId = prop.info.workOrderId
      const { taskId } = item
      const key = workOrderId + '.taskId-' + taskId
      const data = getStorage('inspectionData') || {}
      const newData = omit(data, [key])
      setStorage('inspectionData', newData)
    }
  })
}

// 处理操作详情
const getHandleInfo = item => {
  const { reserveDate = '', role = 'DOCTOR', businessId = '' } = item
  if (role === 'DOCTOR') return
  const businessIds = businessId.split(',')
  // const date = moment(reserveDate).format('YYYY-MM-DD')
  const date = handleTimeShowWeek(reserveDate, 'YYYY-MM-DD')
  // 如果有多个预约单就展示“多个预约单”，否则就显示预约时间
  const info =
    businessIds.length > 1
      ? '多个预约单'
      : ` | ${getTimePeriod(reserveDate)} ${reVisitType[item.revisitType]}`
  return `${date} ${info}`
}

// 点击按钮处理
const handleClick = async (item, caItem) => {
  const res = await getSubOrderStatus(item)
  if (!res) return
  curItem.value = item
  item.workOrderId = prop.info.workOrderId
  const bussCallback = debounce(() => {
    const data = {
      item,
      userInfo: userInfo.value
    }
    caItem.handle(data, res => {
      const { type, status = 'success' } = res
      if (status === 'fail') return REFRESH_MAIN?.emit()
      switch (type) {
        case 'dReDate':
          handleDReDate(item)
          break
        case 'pReDate':
          handlePReDate(item)
          break
        default:
          // 处理已知晓
          dueCallBack()
          break
      }
    })
  }, 200)
  // 判断群组消息是否已读
  const params = {
    workOrderId: item.taskId,
    type: 1 // 复诊提醒工单含有子工单
  }
  const isRead = await finishPrecheck(params)
  if (!isRead) return
  showTraceDetection({
    item,
    caItem,
    cb: () => bussCallback()
  })
  // 新增痕迹检测逻辑
}
const showTraceDetection = params => {
  const { item, caItem, cb } = params
  item.workOrderId = prop.info.workOrderId
  if (item.role === 'DOCTOR') {
    item.ucUserId = item.ucDoctorId
  } else {
    const { ucDoctorId, doctorId } = subTaskReserveInfo.value
    item.doctorId = doctorId
    item.ucDoctorId = ucDoctorId
    item.ucUserId = item.ucPatientId
  }
  const param = {
    title: caItem?.title,
    orderData: {
      ...item,
      operationBehavior: caItem.operationBehavior
    },
    cb
  }
  traceRef?.value?.initModal(param)
}

// 判断当前子任务状态
const getSubOrderStatus = item => {
  const { role, taskId } = item
  return new Promise((resolve, reject) => {
    if (role === 'DOCTOR') return resolve(true)
    subTaskStatus({ taskId })
      .then(message => {
        if (!message) {
          resolve(true)
        } else {
          Modal.warning({
            content: () => message,
            okText: '确定'
          })
          REFRESH_MAIN?.emit()
          resolve(false)
        }
      })
      .catch(() => {
        REFRESH_MAIN?.emit()
        resolve(false)
      })
  })
}
// 处理医生批量修改复诊日期
const handleDReDate = async item => {
  isBatch.value = true
  treatmentRef.value.treatmentInit(item)
}
// 处理患者复诊日期
const handlePReDate = async item => {
  // 处理修改复诊时间
  isBatch.value = false
  const { businessId = '' } = item
  treatmentRef.value.treatmentInit(item, businessId)
}

function dueCallBack() {
  new Promise(resolve => {
    // 刷新工单
    if (curItem.value.role === 'DOCTOR') {
      FINISH_ORDER?.emit()
    } else {
      finishChat()
    }
    resolve(true)
  }).then(() => {
    //清除当前选中的数据
    curItem.value = {}
  })
}
// 子待办完成
const finishChat = async () => {
  // 需要判断这个群聊下面是否还存在处理中工单
  try {
    const { doctorInfo = {}, patientInfo = {} } = workOrderGroupInfo.value || {}
    const params = {
      ucPatientId: patientInfo.ucUserId,
      ucDoctorId: doctorInfo.ucUserId
    }
    const res = await haveProcessingOrder(params)
    if (!res) {
      // 打开医生的私聊群
      // 调用一个接口 处理人和处理中
      const groupId = list.value[0].doctorGroupId
      // 创建一个新的群
      store.commit('workOrder/SET_CHART_ID', groupId)
    }
    REFRESH_LIST?.emit()
    REFRESH_MAIN?.emit()
  } catch {
    //
  }
}
const handleReserveData = item => {
  const { newReserveDate, newRevisitDateType, reserveDataFlag } = item
  try {
    if (reserveDataFlag === 1) {
      return '患者已门诊挂号，但未填写挂号时间'
    } else {
      if (!newReserveDate) {
        return `患者已门诊挂号`
      }
      const month = moment(newReserveDate).month() + 1
      const day = moment(newReserveDate).date()
      // 明天时间
      const tomorrow = moment(new Date()).add(1, 'days')
      const t_month = moment(tomorrow).month() + 1
      const t_day = moment(tomorrow).date()
      let isTomorrow = ''
      if (month === t_month && day === t_day) {
        isTomorrow = '明天'
      }
      const type = ['', '上午', '下午'][newRevisitDateType]
      return `患者已门诊挂号（${month}月${day}日 ${isTomorrow} ${type}）`
    }
  } catch {
    return '--'
  }
}
</script>

<style scoped lang="scss">
.tips {
  width: 100%;
  background: rgba(216, 216, 216, 0.24);
  border-radius: 4px;
  margin-top: 4px;
  padding: 8px;
  color: #666666;
}
.currentTips {
  background: #e8ecf2;
  font-weight: bold;
}
::-webkit-scrollbar {
  width: 2px; /* 滚动条宽度， width：对应竖滚动条的宽度  height：对应横滚动条的高度*/
}
.other-processing-sessions {
  max-height: 257px;
  overflow-y: scroll;

  .list {
    padding: 10px 0;
    border-bottom: 1px dashed #e3e3e3;
    .status {
      font-weight: 400;
      font-size: 12px;
      color: #f5222d;
    }
    .info {
      position: relative;
      // margin-bottom: 4px;
      font-size: 14px;
      .name {
        font-weight: 400;
        color: #333333;
      }

      .right {
        cursor: pointer;
        font-size: 12px;
        color: #1890ff;
        position: absolute;
        right: 0;
      }
    }
    .text {
      font-weight: 400;
      font-size: 12px;
      color: #333333;
    }
    .btn-box {
      display: flex;
      margin: 10px 0 6px;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: center;
      margin-bottom: -10px;
      .button {
        width: 48%;
        margin-bottom: 8px;
        text-align: center;
        line-height: 28px;
        border-radius: 2px;
        padding: 0;
        overflow: hidden;
        font-weight: 400;
        font-size: 12px;
        background: #ff000000;
      }
      .btn {
        border: 1px solid #d9d9d9;
        color: #333333;
      }
      .btnDisabled {
        border: 1px solid #e3e3e3;
        color: #bababa;
      }
    }
    .centent-box {
      margin-top: 7px;
      font-size: 12px;
      color: #999999;
      .cententStyle {
        display: flex;
      }
      .leftIcon {
        position: relative;
        right: 0;
        width: 14px;
        height: 14px;
        margin-right: 5px;
      }
    }
  }
}
</style>
